/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import {
  SAMPLE_TYPE,
  SET_STEP_ONE_DETAILS,
  SET_STEP_TWO_DETAILS,
  SUBMIT_SUCCESSFUL,
  SUBMIT_FAILED,
  SET_IS_LOADING_TRUE,
  SET_IS_LOADING_FALSE,
  CLEAR_ALL_DETAILS,
} from "../actions/types";

const initialState = {
  sampleState: false,
  companyName: "",
  mobileNumber: "",
  email: "",
  address: "",
  rootUserName: "",
  rootUserUsername: "",
  rootUserEmail: "",
  rootUserMobileNumber: "",
  password: "",
  isLoading: false,

  // after res----
  isSubmittedSuccessfully: false,
  resMsg: "",
  resCompnayId: "",
  resCompanyName: "",
  resCompanyUsername: "",
  resCompanyMobileNumber: "",
  resBranch: "",
  resCashier: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SAMPLE_TYPE:
      return {
        ...state,
        sampleState: !payload,
      };
    case SET_STEP_ONE_DETAILS:
      return {
        ...state,
        companyName: payload.companyName,
        mobileNumber: payload.mobileNumber,
        email: payload.email,
        address: payload.address,
      };
    case SET_STEP_TWO_DETAILS:
      return {
        ...state,
        password: payload.password,
      };

    case SUBMIT_SUCCESSFUL:
      return {
        ...state,
        isSubmittedSuccessfully: true,
        resMsg: "Submission Successful.",
        resCompnayId: payload.data.companyId,
        resCompanyName: payload.data.companyName,
        resCompanyUsername: payload.data.companyUsername,
        resCompanyMobileNumber: payload.data.companyMobileNumber,
        resBranch: payload.data.branch,
        resCashier: payload.data.cashier,
      };

    case SUBMIT_FAILED:
      return {
        ...state,
        isSubmittedSuccessfully: false,
        resMsg: "Submission Failed.",
      };

    case SET_IS_LOADING_TRUE:
      return {
        ...state,
        isLoading: true,
      };

    case SET_IS_LOADING_FALSE:
      return {
        ...state,
        isLoading: false,
      };

    case CLEAR_ALL_DETAILS:
      return {
        ...state,
        sampleState: false,
        companyName: "",
        mobileNumber: "",
        email: "",
        address: "",
        rootUserName: "",
        rootUserUsername: "",
        rootUserEmail: "",
        rootUserMobileNumber: "",
        password: "",
        isLoading: false,
      };
    default:
      return state;
  }
}
